import React, { useState } from 'react'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import '../styles/components/FormInput.css'

const FormInput = ({
  type,
  placeholder,
  onChange,
  value,
  className,
  inputClassName
}) => {
  const [isVisible, setIsVisible] = useState(type !== 'password')
  const toggleVisible = () => setIsVisible(!isVisible)

  return (
    <div className={`form-input-container ${className || ''}`}>
      <input className={`form-input-textfield ${inputClassName || ''}`}
        onChange={onChange} value={value}
        type={type === 'password' ? (isVisible ? 'text' : 'password')
          : (type || 'text')}
        placeholder={placeholder} />
      {type === 'password' && (
        isVisible ? (
          <FiEye size={20} color='var(--primary)' className='form-input-eye'
            onClick={toggleVisible} />
        ) : (
          <FiEyeOff size={20} color='var(--primary)' className='form-input-eye'
            onClick={toggleVisible} />
        )
      )}
    </div>
  )
}

export default FormInput



// WEBPACK FOOTER //
// ./src/components/FormInput.js